import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download_time",
  "use": "icon-download_time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-download_time\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12.6,12V9H11.4v4.2H15V12ZM12,18a6,6,0,1,1,6-6A6,6,0,0,1,12,18Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol